import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  getItemCategoryActiveList,
  getProductActiveListByCategoryID,
} from "../MeldiDhamCRUD";
import ElementPage from "../../Elements";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { addItem } from "../../../store/cartSlice";
import { toast } from "react-toastify";

const ProductCategoryPage = () => {
  const [products, setProducts] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const pathUrl = process.env.REACT_APP_API_URL;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    getCategoriesData();
  }, []);

  useEffect(() => {
    if (activeCategory) {
      getProductsData(activeCategory);
    }
  }, [activeCategory]);

  const getCategoriesData = async () => {
    try {
      const res = await getItemCategoryActiveList();
      if (res.data.isSuccess) {
        setCategoryData(res.data.responseObject);
        if (res.data.responseObject.length > 0) {
          setActiveCategory(res.data.responseObject[0].productCategoryID);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getProductsData = async (categoryId) => {
    setLoading(true);
    try {
      const res = await getProductActiveListByCategoryID(categoryId);
      if (res.data.isSuccess) {
        setProducts(res.data.responseObject);
      }
    } finally {
      setLoading(false);
    }
  };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    return item[`${field}_EN`] || item[field];
  };

  const handleAddToCart = (prod) => {
    dispatch(
      addItem({
        id: prod.productID,
        prodCatgryID: prod.productCategoryID,
        name: getLocalized(prod, "productName"),
        categoryName: getLocalized(prod, "productCategoryName"),
        price: prod.price,
        image: prod.photoPath,
        qty: 1,
      })
    );
    toast.success(`${getLocalized(prod, "productName")} added to cart`);
  };

  return (
    <>
      <Container className="py-4">
        {/* 🔸 CATEGORY PILLS */}
        <div className="d-flex gap-3 overflow-auto pb-3 mb-4">
          {categoryData.map((cat) => {
            const isActive = activeCategory === cat.productCategoryID;
            return (
              <div
                key={cat.productCategoryID}
                onClick={() => setActiveCategory(cat.productCategoryID)}
                className={`px-4 py-2 fw-semibold text-nowrap`}
                style={{
                  // cursor: "pointer",
                  // background: isActive ? "#FF4F00" : "#f8f9fa",
                  color: isActive ? "#FF4F00" : "#333",
                  // boxShadow: isActive
                  //   ? "0 4px 12px rgba(255,79,0,0.4)"
                  //   : "0 2px 6px rgba(0,0,0,0.1)",
                  // transition: "all 0.2s ease",
                }}
              >
                {"Category "}
                {getLocalized(cat, "productCategoryName")}
              </div>
            );
          })}
        </div>

        {/* 🔸 PRODUCT LIST */}
        {loading ? (
          <div className="text-center my-5">
            <div className="spinner-border text-danger" />
          </div>
        ) : products.length > 0 ? (
          <Row className="g-4">
            {products.map((prod) => (
              <Col key={prod.productID} xs={12} sm={6} md={4} lg={3}>
                <Card
                  className="h-100 border-0"
                  style={{
                    borderRadius: "16px",
                    boxShadow: "0 8px 18px rgba(0,0,0,0.12)",
                    transition: "transform 0.25s ease",
                  }}
                >
                  {/* IMAGE – FULL VISIBLE */}
                  <div
                    className="d-flex align-items-center justify-content-center bg-light"
                    style={{
                      height: "180px",
                      borderTopLeftRadius: "16px",
                      borderTopRightRadius: "16px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={pathUrl + prod.photoPath}
                      alt={getLocalized(prod, "productName")}
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  <Card.Body className="d-flex flex-column">
                    <p className="fw-semibold mb-1 fs-5">
                      {getLocalized(prod, "productName")}
                    </p>

                    <span className="fw-bold text-danger mb-3">
                      ₹ {prod.price}
                    </span>

                    <div className="mt-auto d-flex gap-2">
                      <Button
                        size="sm"
                        className="w-100"
                        style={{ backgroundColor: "#FF4F00", border: "none" }}
                        onClick={() => handleAddToCart(prod)}
                      >
                        <i className="bi bi-cart-plus me-1"></i>
                        Add
                      </Button>

                      <Link
                        to={`/product/${prod.productID}`}
                        className="btn btn-sm btn-outline-danger w-100"
                      >
                        View
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <div className="text-center py-5">
            <p className="text-muted">{t("no_data")}</p>
            <img src="/assets/logo/15-dark.png" width={60} />
          </div>
        )}
      </Container>

      {/* <ElementPage /> */}
    </>
  );
};

export default ProductCategoryPage;
